/**
 * author: ivanm
 * Deprecated
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var Config = require("registration-assets/config/config.json");
    var ApiResources = require("assets/data/apiResources.json");
    var ValidationUtilities = require("utils/ValidationUtilities");

    var RegistrationSignUpModel = {};
    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {

        RegistrationSignUpModel = BaseModel.extend({

            resource:ApiResources.Registration.Signup,
            name: "RegistrationSignUpModel",
            defaults: {
                email: "",
                language: "",
                origin: "",
                tier: "",
                frequency: ""
            },

            validate: function (attrs) {
                LERegistration.logger.info("RegistrationSignUpModel >> validate >> START");

                var errors = {};
                if (!ValidationUtilities.isValid(attrs.email, Config.validators.email.regex) || ValidationUtilities.isEmpty(attrs.email)) {
                    errors[RegistrationSignUpModel.ERRORS.EMAIL_INVALID] = "LERegistration.PleaseEnterValidEmail";
                }
                if (_.isEmpty(errors)){
                    LERegistration.logger.info("RegistrationSignUpModel >> validate >> is valid");
                    return false;
                }else{
                    LERegistration.logger.info("RegistrationSignUpModel >> validate >> has errors >> errors=" + errors);
                    return errors;
                }
                LERegistration.logger.info("RegistrationSignUpModel >> validate >> END");
            }
        });
    });

    RegistrationSignUpModel.ARRTIBUTES = {
        EMAIL: "email"
    };

    RegistrationSignUpModel.ERRORS = {
        EMAIL_INVALID: "emailInvalid"
    };

    return RegistrationSignUpModel;
});
